module.exports = __webpack_public_path__ + "img/face2.eab545a2.gif";